<script>
  import { fade, draw } from 'svelte/transition'
  // dot
  export let cx
  export let cy
  // text
  export let x
  export let y
  // line
  export let line

  // Pulse marker on active
  export let active
  // Toggle visibility
  export let visible

  export let isSticky
  export let isDesktop = false
  // Stop off screen animations
  export let svgVisible

  function backOut(t) {
    const s = 1.90158
    // eslint-disable-next-line no-param-reassign
    return --t * t * ((s + 1) * t + s) + 1
  }

  function bounce(node, { duration, delay }) {
    return {
      duration,
      delay,
      css: (t) => {
        const eased = backOut(t)

        return `
					transform: scale(${eased});
					`
      },
    }
  }

  function conditionalTransition(node, config) {
    const { transitionType } = config
    if (!isSticky) {
      return null
    }
    if (transitionType === 'draw') {
      return draw(node, config)
    } else if (transitionType === 'fade') {
      return fade(node, config)
    } else if (transitionType === 'bounce') {
      return bounce(node, config)
    }
    console.error('fant ikke transition: ', transitionType)
  }
</script>

{#if visible}
  <g out:fade>
    <text
      in:conditionalTransition={{ delay: 1700, duration: 800, transitionType: 'fade' }}
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="NRK Sans Variable"
      class="label-primary"
      font-size={isDesktop ? 16 : 14}
      font-weight={isDesktop && 'bold'}
      letter-spacing="0em"
      {x}
      {y}><slot /></text
    >
    <path
      d={line}
      stroke="#EEF5FF"
      in:conditionalTransition={{ duration: 1200, delay: 0, transitionType: 'draw' }}
    />
    <g transform={`translate(${cx},${cy})`}>
      <circle
        cx="0"
        cy="0"
        r="6"
        in:conditionalTransition={{ duration: 1000, delay: 1100, transitionType: 'bounce' }}
      />
      {#if active && svgVisible}
        <circle cx="0" cy="0" r="8" class="pulse" />
      {/if}
    </g>
  </g>
{/if}

<style>
  circle:not(.pulse) {
    fill: var(--dhsa-color-accent-primary);
  }

  .pulse {
    stroke: var(--dhsa-color-accent-primary);
    fill: transparent;
    stroke-width: 2px;
    stroke-opacity: 0;
    animation: pulse 2.5s infinite linear 1.3s;
  }

  .label-primary {
    font-variation-settings: var(--nrk-sans-regular);
  }

  @keyframes pulse {
    from {
      stroke-opacity: 1;
      transform: scale(0.5);
    }
    to {
      stroke-width: 0;
      stroke-opacity: 0;
      transform: scale(3);
    }
  }
</style>
